import { render, staticRenderFns } from "./Storification.vue?vue&type=template&id=5d620938&"
import script from "./Storification.vue?vue&type=script&lang=js&"
export * from "./Storification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports